<template>  
  <!-- Mobile Navbar -->  
  <nav class="navbar d-block d-sm-block" style="margin-bottom: 0px;">  
    <div id="mobileSearch" class="search-header" v-show="mobileSearchOpen">  
      <div class="search-navbar">  
        <button type="button" id="btn-toggle-close-search" @click="closeMobileSearch"></button>  
        <form action="/search" id="mobileSearchForm">  
          <input  
            type="text"  
            name="query"  
            class="form-control search-input"  
            :placeholder="SearchPlaceholder"  
            required  
            pattern="^(?=.*[a-zA-Z0-9\u4E00-\u9FFF@])(?! )[a-zA-Z0-9\u4E00-\u9FFF\s,\./\-\u2013#\$@]{2,}$"  
            title="Please input at least 2 characters and avoid special characters."  
            id="mobile-search-input"  
            ref="mobileSearchInput"  
            maxlength="1024"  
          />  
        </form>  
      </div>  
    </div>  
    <div class="navbar-header navbar-header-mobile">  
      <!-- Toggle Button -->  
      <button  
        type="button"  
        class="navbar-toggler"  
        @click="toggleMobileNavbar"  
        aria-controls="mobileNavbar"  
        aria-expanded="false"  
        aria-label="Toggle navigation"  
        ref="btnToggleMenu"  
      >  
        <span class="navbar-toggler-icon"></span>  
      </button>  
      <a href="/" style="text-align: center; grid-row: 1/3;">  
        <img  
          id="dynamic-image-mobile"  
          src="@/assets/hku_portal_dev_logo.svg"  
          alt="Mobile Logo"  
          class="mobile-hku-logo"  
        />  
      </a>  
      <button  
        type="button"  
        id="btn-toggle-search"  
        class="navbar-toggle"  
        style="border: 0; cursor: pointer;"  
        @click="openMobileSearch"  
      >  
        <span class="btn-toggle-search-icon"><font-awesome-icon :icon="['fas', 'magnifying-glass']" /></span>  
      </button>  
    </div>  
  </nav>  
  <div  
    id="mobileNavbar"  
    ref="mobileNavbar"  
    :class="['collapse', 'navbar-collapse', 'no-padding-left-right', { show: mobileNavbarOpen }]"  
  >  
    <nav id="sidebar">  
            <!-- TODO: navigation menu -->
            <!-- Language selection -->  
            <ul class="list-unstyled components newicon-mobile">  
              <li class="folder">  
                <a href="#language-card-mobile" data-toggle="collapse" aria-expanded="false">  
                  <img src="@/assets/icon_lang.svg" class="nav_img" />  
                  <span id="language-text-mobile"></span>  
                </a>  
                <ul id="language-card-mobile" class="list-unstyled collapse">  
                  <li><a id="en-US" href="#" class="portal-link"><span>EN</span></a></li>  
                  <li><a id="zh-CN" href="#" class="portal-link"><span>简</span></a></li>  
                  <li><a id="zh-HK" href="#" class="portal-link"><span>繁</span></a></li>  
                </ul>  
              </li>  
              <li class="folder task-list-mobile">  
                <a class="task-list-mobile-link" href="/task-list">  
                  <img src="@/assets/icon_task.svg" class="nav_img" />  
                  <span>{{ getSnippet('hku-portal-content-snippets-pending-task') }}</span>  
                  <div class="task-list-number-circle task-list-number-circle-header" id="mobile-header-task-list-number-circle"></div>  
                </a>  
              </li>  
              <li class="folder user-guide-mobile">  
                <a class="user-guide-mobile-link" href="https://userguide.hku.hk/staffportal">  
                  <img src="@/assets/icon_user_guide.svg" class="nav_img" />  
                  <span>{{ getSnippet('hku-portal-content-snippets-user-guide') }}</span>  
                </a>  
              </li>  
            </ul>  
            <div class="profile-card">  
              <div class="user-info">  
                <img  
                  src="@/assets/Icon_default_profile.png"  
                  alt="Cloud Chen"  
                  class="circle"  
                  style="border-top-left-radius: 50%; border-top-right-radius: 50%; border-bottom-right-radius: 50%; border-bottom-left-radius: 50%;padding: 10px;"  
                />  
                <ul>  
                  <p class="name">{{ userDisplayName }}</p>  
                  <p></p>  
                  <p>{{ user.jobtitle }}</p>  
                  <p>{{ user.department }}</p>  
                  <p>{{ user.address1_line1 }}</p>  
                </ul>  
              </div>  
              <div style="display:grid;padding-bottom: 160px;padding-left: 20px;">  
                <a href="/user-profile" class="hkuText">{{ getSnippet('hku-portal-content-snippets-sub-wrap-profile') }}</a>  
                <a href="/settings" class="hkuText">{{ getSnippet('hku-portal-content-snippets-sub-wrap-settings') }}</a>  
                <a class="hkuText" :href="signouturl">{{ getSnippet('hku-portal-content-snippets-sub-wrap-logout') }}</a>  
              </div>  
            </div>  
        </nav>  
      </div>  
    
    <!-- topbar in desktop -->  
    <nav class="navbar hidden-xs hidden-sm">  
      <div class="container-fluid">  
        <div class="navbar-header mr-auto">  
          <a href="/"><img id="dynamic-image" src="@/assets/hku_portal_dev_logo.svg" alt="Desktop Logo" class="hku-logo" /></a>  
        </div>  
        <div id="navbar">  
        <!-- <div id="navbar" class="navbar-collapse collapse">     -->
          <div class="navbar-right d-flex align-items-center flex-wrap">  
            <!-- Add flex-wrap -->  
            <div class="navbar-form mb-2">  
              <!-- Add bottom margin -->  
              <div class="input-group">  
                <span class="input-group-addon" style="border: 0; background: transparent;cursor: pointer;"><font-awesome-icon :icon="['fas', 'magnifying-glass']" /></span>  
                <form action="/search" id="search">  
                  <input  
                    type="text"  
                    name="query"  
                    class="form-control search-input"  
                    :placeholder="getSnippet('hku-portal-content-snippets-search')"  
                    required=""  
                    pattern="^(?=.*[a-zA-Z0-9\u4E00-\u9FFF@])(?! )[a-zA-Z0-9\u4E00-\u9FFF\s,\.\(\)\/\-\u2013\+\:\;\=\?\u0022\u0027\*\&\#\$\@]{2,}$"  
                    title="Please input at least 2 characters and avoid special characters."  
                    id="desktop-search-input"  
                    maxlength="1024"  
                  />  
                </form>  
              </div>  
            </div>  
            <div class="newicon ml-1 mb-2">  
              <button id="language-button" class="d-flex align-items-center" style="color:#25401e;padding:10px;">  
                <img src="@/assets/icon_lang.svg" class="d-flex align-items-center" style="height: 24px;padding:3px;pointer-events: none;" />  
                <span id="language-text"></span>  
                <img src="@/assets/icon_lang_arrow.svg" style="height:24px;padding:3px;pointer-events: none;" />  
              </button>  
              <div class="language-sub-menu-wrap" id="language-card-desktop">  
                <div class="language-sub-menu" style="display:none;">  
                  <div class="language-info">  
                    <a id="en-US" href="#">EN</a>  
                    <a id="zh-CN" href="#">简</a>  
                    <a id="zh-HK" href="#">繁</a>  
                  </div>  
                </div>  
              </div>  
            </div>  
            <a href="/explore-all-links" class="classicportallink d-flex align-items-center" style="color:#25401e;padding:3px;">  
              <img src="@/assets/icon_siteMap.svg" style="height:2.3em;padding:3px;" />{{ getSnippet('hku-portal-content-snippets-sitemap') }}  
            </a>  
            <a href="https://userguide.hku.hk/staffportal" id="user-guide-link" target="_blank" data-toggle="tooltip" data-placement="top" :title="snippets['hku-portal-content-snippets-user-guide']">  
              <img src="@/assets/icon_user_guide.svg" alt="Task List" width="30px" id="user-guide-icon" />  
            </a>  
            <img  
              src="@/assets/icon_task.svg"  
              alt="Task List"  
              width="30px"  
              id="task-list-icon"  
              ref="taskListIcon"  
              @click="toggleTaskListCard"  
            />
            <div class="task-list-number-circle task-list-number-circle-header" id="header-task-list-number-circle" ref="headerTaskListNumberCircle" @click="toggleTaskListCard"></div>
            <div class="task-list-sub-menu-wrap" id="task-list-card-desktop" ref="taskListCardDesktop" v-show="taskListCardVisible" @click.stop> 
              <div class="task-list-sub-menu" id="task-list-sub-menu-id" style="height: 515px;">  
                <div id="task-list-header">  
                  <div class="task-list-title-container">  
                    <h3 class="task-list-title">{{ getSnippet('hku-portal-content-snippets-pending-task') }}</h3>  
                  </div>  
                  <div class="task-list-header-container">  
                    <img src="@/assets/Approval_sync.svg" class="task-list-refresh refresh" @click="getApprovalsData" />  
                    <!-- <p class="task-list-last-updated" id="task-list-last-updated"></p> -->  
                  </div>  
                </div>  
                <div id="task-list-spinner" style="text-align: center;">  
                  <div class="task-list-spinner"></div>  
                </div>  
                <div class="task-list-info" id="task-list-pending-info-content">  
                  <div class="header-pending-approvals" id="header-pending-approvals-content"></div>  
                  <!-- <ul id="header-task-list-list">
                    <li v-for="(task, index) in resultTaskListData.results.entities" :key="task.tasklist_id" v-if="index < 6">
                        <a
                        :href="
                            website.selected_language.code === 'zh-CN'
                            ? (task.tasklist_simp_url || task.tasklist_url)
                            : website.selected_language.code === 'zh-HK'
                                ? (task.tasklist_trad_url || task.tasklist_url)
                                : task.tasklist_url
                        "
                        class="task-list-link"
                        :completebyportal="task.tasklist_completebyportal"
                        :tasklistid="task.tasklist_id"
                        target="_blank"
                        @click="checkCompleteTaskList(task.tasklist_completebyportal, task.tasklist_id)"
                        >
                        <img :src="task.tasklist_iconimageurl || '/icon_doc.svg'" alt="Task List" width="30px" class="task-list-full-page-icon" />
                        <p class="hkuText">
                            {{
                            website.selected_language.code === 'zh-CN'
                                ? (task.tasklist_simp_title || task.tasklist_title)
                                : website.selected_language.code === 'zh-HK'
                                ? (task.tasklist_trad_title || task.tasklist_title)
                                : task.tasklist_title
                            }}
                        </p>
                        <button id="task_button" class="btn btn-flat">
                            <span class="task-list-button-text">
                            {{
                                website.selected_language.code === 'zh-CN'
                                ? (task.tasklist_simp_buttonlabel || snippets['hku-portal-content-snippets-go'])
                                : website.selected_language.code === 'zh-HK'
                                    ? (task.tasklist_trad_buttonlabel || snippets['hku-portal-content-snippets-go'])
                                    : (task.tasklist_buttonlabel || snippets['hku-portal-content-snippets-go'])
                            }}
                            </span>
                        </button>
                        </a>
                    </li>
                    </ul> -->
                </div>   
                <div id="task-list-header-no-task">  
                    <p class="hkuText">{{ getSnippet('hku-portal-content-snippets-no-task') }}</p>  
                </div>  
                <div class="task-list-full-text">  
                <a href="/task-list" class="hkuText">{{ getSnippet('hku-portal-content-snippets-view-all-task') }}</a>  
                </div>  
            </div>  
        </div>  
      <img  
        src="@/assets/Icon_default_profile.png"  
        class="img-circle ml-1"  
        width="30px"  
        id="user-profile-img-desktop"  
        ref="userProfileImgDesktop"  
        @click="toggleProfileCard"  
      />
    <div class="profile-sub-menu-wrap" id="profile-card-desktop" ref="profileCardDesktop" v-show="profileCardVisible" @click.stop> 
    <div class="profile-sub-menu">  
        <div class="user-info">  
        <img  
            src="@/assets/Icon_default_profile.png"  
            alt="Cloud Chen"  
            class="circle"  
            style="border-top-left-radius: 50%; border-top-right-radius: 50%; border-bottom-right-radius: 50%; border-bottom-left-radius: 50%;padding: 10px;"  
        />  
        <ul>  
            <p class="name">{{ userDisplayName }}</p>  
            <p></p>  
            <p>{{ user.jobtitle }}</p>  
            <p>{{ user.department }}</p>  
            <p>{{ user.address1_line1 }}</p>  
        </ul>  
        </div>  
        <hr>  
          <div class="textLeft profile-link">  
            <a href="/user-profile" class="hkuText">{{ getSnippet('hku-portal-content-snippets-sub-wrap-profile') }}</a>
            <a href="/settings" class="hkuText">{{ getSnippet('hku-portal-content-snippets-sub-wrap-settings') }}</a>
            <a @click="logoutPortal" class="hkuText">{{ getSnippet('hku-portal-content-snippets-sub-wrap-logout') }}</a>
          </div>
        </div>  
    </div>  
    </div>  
    </div>  
    </div>  
</nav>  
</template>  

<script>
import { patchDataverse } from '@/functions/Dataverse';
import { logout } from '@/functions/site';

export default {
  data() {
    return {
      snippets: {
        'hku-portal-content-snippets-search': {
          'en': 'Search for services',
          'zh-CN': '搜索',
          'zh-HK': '搜尋'
        },
        'hku-portal-content-snippets-pending-task': {
          'en': 'Pending Task',
          'zh-CN': '待办任务',
          'zh-HK': '待辦任務'
        },
        'hku-portal-content-snippets-user-guide': {
          'en': 'User Guide',
          'zh-CN': '用户指南',
          'zh-HK': '用戶指南'
        },
        'hku-portal-content-snippets-no-task': {
          'en': 'No Task',
          'zh-CN': '没有任务',
          'zh-HK': '沒有任務'
        },
        'hku-portal-content-snippets-view-all-task': {
          'en': 'View All Tasks',
          'zh-CN': '查看所有任务',
          'zh-HK': '查看所有任務'
        },
        'hku-portal-content-snippets-sub-wrap-profile': {
          'en': 'Profile',
          'zh-CN': '个人资料',
          'zh-HK': '個人資料'
        },
        'hku-portal-content-snippets-sub-wrap-settings': {
          'en': 'Settings',
          'zh-CN': '设置',
          'zh-HK': '設置'
        },
        'hku-portal-content-snippets-sub-wrap-logout': {
          'en': 'Logout',
          'zh-CN': '登出',
          'zh-HK': '登出'
        },
        'hku-portal-content-snippets-sitemap': {
          'en': 'Sitemap',
          'zh-CN': '网站地图',
          'zh-HK': '網站地圖'
        },
        'hku-portal-content-snippets-go': {
          'en': 'Go',
          'zh-CN': '去',
          'zh-HK': '去'
        }
      },
      SearchPlaceholder: 'Search for services',
      user: {
        jobtitle: 'IT Officer',
        department: 'Information Technology Services',
        address1_line1: '1/F Main Library Old Wing',
        fullname: 'Marco Ho'
      },
      userDisplayName: 'Marco Ho',
      selectedLanguage: 'en', // Default language  
      mobileNavbarOpen: false,  
      mobileSearchOpen: false,
      profileCardVisible: false, // For profile card visibility  
      taskListCardVisible: false, // For task list card visibility  
      mobileValid: false,  
      collapseNavbar: false,  
      lastPosition: 0,  
      userCategory: [],  
      // ... other data properties as needed  
    };  
  },  
  methods: {  
    async logoutPortal() {  
      await logout();  
    },  
    getSnippet(key) {  
      this.selectedLanguage = 'en'; // Default language  
      return this.snippets[key][this.selectedLanguage] || this.snippets[key]['en'];  
    },  
    toggleMobileNavbar() {  
      this.mobileNavbarOpen = !this.mobileNavbarOpen;  
      // Optionally handle body overflow if needed:  
      document.body.style.overflow = this.mobileNavbarOpen ? 'hidden' : 'scroll';  
    },  
    openMobileSearch() {  
      this.mobileSearchOpen = true;  
      document.body.style.overflow = 'hidden';  
      this.$nextTick(() => {  
        this.$refs.mobileSearchInput.focus();  
      });  
    },  
    closeMobileSearch() {  
      this.mobileSearchOpen = false;  
      document.body.style.overflow = 'scroll';  
    },  
    toggleProfileCard() {  
      this.profileCardVisible = !this.profileCardVisible;  
    },  
    toggleTaskListCard() {  
      this.taskListCardVisible = !this.taskListCardVisible;  
    },  
    handleDocumentClick(event) {  
      // Close mobile navbar if click outside  
      if (this.mobileNavbarOpen) {  
        let mobileNavbar = this.$refs.mobileNavbar;  
        let btnToggleMenu = this.$refs.btnToggleMenu;  
        if (  
          mobileNavbar &&  
          !mobileNavbar.contains(event.target) &&  
          btnToggleMenu &&  
          !btnToggleMenu.contains(event.target)  
        ) {  
          this.toggleMobileNavbar();  
        }  
      }  
      // Close profile card  
      if (this.profileCardVisible) {  
        let profileCard = this.$refs.profileCardDesktop;  
        let userProfileImg = this.$refs.userProfileImgDesktop;  
        if (  
          profileCard &&  
          !profileCard.contains(event.target) &&  
          userProfileImg &&  
          !userProfileImg.contains(event.target)  
        ) {  
          this.profileCardVisible = false;  
        }  
      }  
      // Close task list card  
      if (this.taskListCardVisible) {  
        let taskListCard = this.$refs.taskListCardDesktop;  
        let taskListIcon = this.$refs.taskListIcon;  
        let headerTaskListNumberCircle = this.$refs.headerTaskListNumberCircle;  
        if (  
          taskListCard &&  
          !taskListCard.contains(event.target) &&  
          !taskListIcon.contains(event.target) &&  
          !headerTaskListNumberCircle.contains(event.target)  
        ) {  
          this.taskListCardVisible = false;  
        }  
      }  
    },  
    searchIconClick() {  
      let formInput = this.$refs.desktopSearchInput;  
      if (formInput.value.length > 0) {  
        if (formInput.checkValidity()) {  
          formInput.closest('form').submit();  
        } else {  
          formInput.reportValidity();  
        }  
      } else {  
        formInput.focus();  
      }  
    },  
    mobileSearchBtnClick() {  
      let formInput = this.$refs.mobileSearchInput;  
      let form = this.$refs.mobileSearchForm;  
      if (formInput.value.length > 0) {  
        if (formInput.checkValidity()) {  
          form.submit();  
        } else {  
          formInput.reportValidity();  
        }  
      } else {  
        formInput.focus();  
      }  
    },  
    handleResize() {  
      this.collapseNavbar = false;  
      if (window.innerWidth < 1605 && !this.$refs.sidebarElement.classList.contains('hovering')) {  
        setTimeout(this.delayRemoveClass, 1000);  
      } else if (window.innerWidth < 1100 && !this.$refs.sidebarElement.classList.contains('hovering')) {  
        this.delayRemoveClass();  
      } else {  
        if (!this.$refs.hiddenBtn.classList.contains('sidebarBlock')) {  
          this.$refs.hiddenBtn.classList.add('sidebarDivBlock');  
          this.$refs.sidebarElement.classList.add('sidebarBlock');  
          this.$refs.hiddenColElement.classList.add('col-sm-3');  
          this.$refs.sidebarHidden.classList.remove('sidebar-block');  
          this.$refs.sidebarHidden.classList.add('sidebar-hidden');  
        }  
      }  
    },  
    delayRemoveClass() {  
      if (this.$refs.sidebarElement.classList.contains('hovering')) {  
        clearTimeout(this.timeout);  
      } else {  
        this.$refs.hiddenBtn.classList.remove('sidebarDivBlock');  
        this.$refs.sidebarElement.classList.remove('sidebarBlock');  
        this.$refs.hiddenColElement.classList.remove('col-sm-3');  
        this.$refs.sidebarHidden.classList.remove('sidebar-hidden');  
        this.$refs.sidebarHidden.classList.add('sidebar-block');  
      }  
    },  
    // ... other methods such as eventClick, addAddRecentLinkListener, etc.  
    getApprovalsData() {  
      // Your JavaScript logic here  
    },  
    checkCompleteTaskList(completeByPortal, taskListId) {  
      if (completeByPortal === 'true') {  
        this.completeTaskListItem(taskListId);  
      }  
    },  
    completeTaskListItem(taskListId) {  
      patchDataverse('sdportal_tasklist', taskListId, { sdportal_completed: true });  
    },  
  },  
  mounted() {  
    document.addEventListener('click', this.handleDocumentClick);  
    window.addEventListener('resize', this.handleResize);  
  
    // Initialize user category  
    let rawUserCategoryList = JSON.stringify("{{rawUserCategoryNameList}}")  
      .split(/[",]/)  
      .filter((item) => item.trim() !== '');  
    this.userCategory = rawUserCategoryList.map((category) => ({  
      userCategory: category,  
    }));  
  
    // Check mobile validity  
    this.mobileValid = window.innerWidth <= 767;  
  
    // Initialize masonry (if needed)  
    // this.$nextTick(() => {  
    //   $('.grid').masonry({  
    //     itemSelector: '.grid-item',  
    //     horizontalOrder: true,  
    //     percentPosition: true,  
    //     gutter: 10,  
    //     transitionDuration: 0,  
    //   });  
    // });  
    // Load existing recent links  
    // this.handleRawExistRecentLinkData();  
  }
  // beforeDestroy() {  
  //   document.removeEventListener('click', this.handleDocumentClick);  
  //   window.removeEventListener('resize', this.handleResize);  
  //   // Remove other event listeners if any  
  // },  
};  
</script>
  
<style scoped>  
/* Your CSS styles here */  
</style> 